const palette = {
  primary: {
    A100: '#F5F9FF',
    A200: '#A3C1F5',
    A300: '#A3C1F5',
    A400: '#002884',
    A500: '#002464',
    A600: '#001B4C',
    main: '#002464',
    A700: '#001B4C',
    A800: '#001B4C',
  },
  secondary: {
    A100: '#F5F9FF',
    A200: '#DDE5FF',
    A300: '#A3B7F5',
    A400: '#5483FF',
    A500: '#295EFF',
    A600: '#0038E1',
    main: '#295EFF',
    A700: '#0038E1',
    A800: '#0038E1',
  },
  transition: {
    A100: '#295EFF',
    A200: '#002884',
    A300: '#002464',
    A400: '#002884',
    A500: '#0038E1',
    A600: '#0038E1',
    A700: '#295EFF',
  },
  gray: {
    A100: '#F2F4F7',
    A200: '#EAECF0',
    A300: '#D0D5DD',
    A400: '#98A2B3',
    A500: '#667085',
    main: '#667085',
    A600: '#475467',
    A700: '#344054',
    A800: '#101828',
  },
  success: {
    A100: '#EEFFED',
    A200: '#D5FBD3',
    A300: '#A9F8AF',
    A400: '#7BEC8E',
    main: '#58D97A',
    A600: '#28C160',
    A700: '#1DA55C',
    A800: '#148A57',
  },
  error: {
    A100: '#FFF1E8',
    A200: '#FEE9DC',
    A300: '#FECDBA',
    A400: '#FDAB97',
    main: '#FC8B7D',
    A600: '#FB5752',
    A700: '#D73B44',
    A800: '#B4293C',
  },
  info: {
    A100: '#DDEFFF',
    A200: '#C9E3FB',
    A300: '#95C7F7',
    A400: '#5E9FE9',
    main: '#3579D3',
    A600: '#0148B7',
    A700: '#00379D',
    A800: '#002983',
  },
  warning: {
    A100: '#FFFAEB',
    A200: '#FFF5CE',
    A300: '#FFE79C',
    A400: '#FFD66C',
    main: '#FFC647',
    A600: '#FFAB0A',
    A700: '#DB8B07',
    A800: '#B76D05',
  },
  text: {
    highlight: '#5483FF',
    emphasis: '#295EFF',
    main: '#323232',
    // We need to get rid of this color, but in the meantime
    // we need to keep it for the alert messages :(
  },
  contrast: {
    A500: '#1B3572',
    A600: '#1B3060',
    A700: '#18284D',
    A800: '#090D17',
  },
};

export default palette;
